/* eslint-disable */
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var gogoproto_gogo_pb = require('../../gogoproto/gogo_pb.js');
goog.object.extend(proto, gogoproto_gogo_pb);
var rpc_admin_image_pb = require('../../rpc/admin/image_pb.js');
goog.object.extend(proto, rpc_admin_image_pb);
goog.exportSymbol('proto.admin.GetRsrProductRequest', null, global);
goog.exportSymbol('proto.admin.RsrProduct', null, global);
goog.exportSymbol('proto.admin.RsrProduct.RsrRestriction', null, global);
goog.exportSymbol('proto.admin.RsrProduct.RsrRestriction.Detail', null, global);
goog.exportSymbol('proto.admin.RsrProduct.RsrRestriction.Level', null, global);
goog.exportSymbol('proto.admin.RsrProduct.RsrXref', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.RsrProduct = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.admin.RsrProduct.repeatedFields_, null);
};
goog.inherits(proto.admin.RsrProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.RsrProduct.displayName = 'proto.admin.RsrProduct';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.RsrProduct.RsrXref = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.RsrProduct.RsrXref, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.RsrProduct.RsrXref.displayName = 'proto.admin.RsrProduct.RsrXref';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.RsrProduct.RsrRestriction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.RsrProduct.RsrRestriction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.RsrProduct.RsrRestriction.displayName = 'proto.admin.RsrProduct.RsrRestriction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admin.GetRsrProductRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admin.GetRsrProductRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admin.GetRsrProductRequest.displayName = 'proto.admin.GetRsrProductRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.admin.RsrProduct.repeatedFields_ = [122,123,124,128];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.RsrProduct.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.RsrProduct.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.RsrProduct} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.RsrProduct.toObject = function(includeInstance, msg) {
  var f, obj = {
    rsrStockNumber: jspb.Message.getFieldWithDefault(msg, 1, ""),
    upcCode: jspb.Message.getFieldWithDefault(msg, 2, ""),
    productDescription: jspb.Message.getFieldWithDefault(msg, 3, ""),
    department: jspb.Message.getFieldWithDefault(msg, 4, ""),
    manufacturerId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    retailPrice: +jspb.Message.getFieldWithDefault(msg, 6, 0.0),
    rsrRegularPrice: +jspb.Message.getFieldWithDefault(msg, 7, 0.0),
    productWeight: +jspb.Message.getFieldWithDefault(msg, 8, 0.0),
    inventoryQuantity: jspb.Message.getFieldWithDefault(msg, 9, 0),
    model: jspb.Message.getFieldWithDefault(msg, 10, ""),
    fullManufacturerName: jspb.Message.getFieldWithDefault(msg, 11, ""),
    manufacturerPartNumber: jspb.Message.getFieldWithDefault(msg, 12, ""),
    allocatedCloseoutDeleted: jspb.Message.getFieldWithDefault(msg, 13, ""),
    expandedProductDescription: jspb.Message.getFieldWithDefault(msg, 14, ""),
    imageName: jspb.Message.getFieldWithDefault(msg, 15, ""),
    groundShipmentsOnly: jspb.Message.getFieldWithDefault(msg, 67, false),
    adultSignatureRequired: jspb.Message.getFieldWithDefault(msg, 68, false),
    blockedFromDropShip: jspb.Message.getFieldWithDefault(msg, 69, false),
    dateEntered: jspb.Message.getFieldWithDefault(msg, 70, ""),
    retailMap: +jspb.Message.getFieldWithDefault(msg, 71, 0.0),
    imageDisclaimer: jspb.Message.getFieldWithDefault(msg, 72, ""),
    shippingLength: +jspb.Message.getFieldWithDefault(msg, 73, 0.0),
    shippingWidth: +jspb.Message.getFieldWithDefault(msg, 74, 0.0),
    shippingHeight: +jspb.Message.getFieldWithDefault(msg, 75, 0.0),
    prop65: jspb.Message.getFieldWithDefault(msg, 76, false),
    fulfillment: jspb.Message.getFieldWithDefault(msg, 77, false),
    accessories: jspb.Message.getFieldWithDefault(msg, 78, ""),
    action: jspb.Message.getFieldWithDefault(msg, 79, ""),
    typeOfBarrel: jspb.Message.getFieldWithDefault(msg, 80, ""),
    barrelLength: jspb.Message.getFieldWithDefault(msg, 81, ""),
    catalogCode: jspb.Message.getFieldWithDefault(msg, 82, ""),
    chamber: jspb.Message.getFieldWithDefault(msg, 83, ""),
    chokes: jspb.Message.getFieldWithDefault(msg, 84, ""),
    condition: jspb.Message.getFieldWithDefault(msg, 85, ""),
    capacity: jspb.Message.getFieldWithDefault(msg, 86, ""),
    description: jspb.Message.getFieldWithDefault(msg, 87, ""),
    dram: jspb.Message.getFieldWithDefault(msg, 88, ""),
    edge: jspb.Message.getFieldWithDefault(msg, 89, ""),
    firingCasing: jspb.Message.getFieldWithDefault(msg, 90, ""),
    finishColor: jspb.Message.getFieldWithDefault(msg, 91, ""),
    fit1: jspb.Message.getFieldWithDefault(msg, 92, ""),
    fit2: jspb.Message.getFieldWithDefault(msg, 93, ""),
    feetPerSecond: jspb.Message.getFieldWithDefault(msg, 94, ""),
    frameMaterial: jspb.Message.getFieldWithDefault(msg, 95, ""),
    caliber1: jspb.Message.getFieldWithDefault(msg, 96, ""),
    caliber2: jspb.Message.getFieldWithDefault(msg, 97, ""),
    grainWeight: jspb.Message.getFieldWithDefault(msg, 98, ""),
    gripsStock: jspb.Message.getFieldWithDefault(msg, 99, ""),
    hand: jspb.Message.getFieldWithDefault(msg, 100, ""),
    manufacturer: jspb.Message.getFieldWithDefault(msg, 101, ""),
    manufacturerPart: jspb.Message.getFieldWithDefault(msg, 102, ""),
    manufacturerWeight: jspb.Message.getFieldWithDefault(msg, 103, ""),
    moa: jspb.Message.getFieldWithDefault(msg, 104, ""),
    model1: jspb.Message.getFieldWithDefault(msg, 105, ""),
    model2: jspb.Message.getFieldWithDefault(msg, 106, ""),
    newStock: jspb.Message.getFieldWithDefault(msg, 107, ""),
    nationalStockNumber: jspb.Message.getFieldWithDefault(msg, 108, ""),
    objective: jspb.Message.getFieldWithDefault(msg, 109, ""),
    ounceOfShot: jspb.Message.getFieldWithDefault(msg, 110, ""),
    packaging: jspb.Message.getFieldWithDefault(msg, 111, ""),
    power: jspb.Message.getFieldWithDefault(msg, 112, ""),
    reticle: jspb.Message.getFieldWithDefault(msg, 113, ""),
    safety: jspb.Message.getFieldWithDefault(msg, 114, ""),
    sights: jspb.Message.getFieldWithDefault(msg, 115, ""),
    size: jspb.Message.getFieldWithDefault(msg, 116, ""),
    type: jspb.Message.getFieldWithDefault(msg, 117, ""),
    unitsPerBox: jspb.Message.getFieldWithDefault(msg, 118, ""),
    unitsPerCase: jspb.Message.getFieldWithDefault(msg, 119, ""),
    wtCharacteristics: jspb.Message.getFieldWithDefault(msg, 120, ""),
    subCategory: jspb.Message.getFieldWithDefault(msg, 121, ""),
    diameter: jspb.Message.getFieldWithDefault(msg, 129, ""),
    xrefsList: jspb.Message.toObjectList(msg.getXrefsList(),
    proto.admin.RsrProduct.RsrXref.toObject, includeInstance),
    imagesList: jspb.Message.toObjectList(msg.getImagesList(),
    rpc_admin_image_pb.Image.toObject, includeInstance),
    restrictionsList: jspb.Message.toObjectList(msg.getRestrictionsList(),
    proto.admin.RsrProduct.RsrRestriction.toObject, includeInstance),
    productMessageType: jspb.Message.getFieldWithDefault(msg, 125, ""),
    productMessage: jspb.Message.getFieldWithDefault(msg, 126, ""),
    sellCopy: jspb.Message.getFieldWithDefault(msg, 127, ""),
    featuresList: jspb.Message.getRepeatedField(msg, 128)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.RsrProduct}
 */
proto.admin.RsrProduct.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.RsrProduct;
  return proto.admin.RsrProduct.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.RsrProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.RsrProduct}
 */
proto.admin.RsrProduct.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRsrStockNumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpcCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDepartment(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setManufacturerId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRetailPrice(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRsrRegularPrice(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProductWeight(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setInventoryQuantity(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setFullManufacturerName(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setManufacturerPartNumber(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAllocatedCloseoutDeleted(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpandedProductDescription(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageName(value);
      break;
    case 67:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGroundShipmentsOnly(value);
      break;
    case 68:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAdultSignatureRequired(value);
      break;
    case 69:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBlockedFromDropShip(value);
      break;
    case 70:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateEntered(value);
      break;
    case 71:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRetailMap(value);
      break;
    case 72:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageDisclaimer(value);
      break;
    case 73:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setShippingLength(value);
      break;
    case 74:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setShippingWidth(value);
      break;
    case 75:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setShippingHeight(value);
      break;
    case 76:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setProp65(value);
      break;
    case 77:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFulfillment(value);
      break;
    case 78:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessories(value);
      break;
    case 79:
      var value = /** @type {string} */ (reader.readString());
      msg.setAction(value);
      break;
    case 80:
      var value = /** @type {string} */ (reader.readString());
      msg.setTypeOfBarrel(value);
      break;
    case 81:
      var value = /** @type {string} */ (reader.readString());
      msg.setBarrelLength(value);
      break;
    case 82:
      var value = /** @type {string} */ (reader.readString());
      msg.setCatalogCode(value);
      break;
    case 83:
      var value = /** @type {string} */ (reader.readString());
      msg.setChamber(value);
      break;
    case 84:
      var value = /** @type {string} */ (reader.readString());
      msg.setChokes(value);
      break;
    case 85:
      var value = /** @type {string} */ (reader.readString());
      msg.setCondition(value);
      break;
    case 86:
      var value = /** @type {string} */ (reader.readString());
      msg.setCapacity(value);
      break;
    case 87:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 88:
      var value = /** @type {string} */ (reader.readString());
      msg.setDram(value);
      break;
    case 89:
      var value = /** @type {string} */ (reader.readString());
      msg.setEdge(value);
      break;
    case 90:
      var value = /** @type {string} */ (reader.readString());
      msg.setFiringCasing(value);
      break;
    case 91:
      var value = /** @type {string} */ (reader.readString());
      msg.setFinishColor(value);
      break;
    case 92:
      var value = /** @type {string} */ (reader.readString());
      msg.setFit1(value);
      break;
    case 93:
      var value = /** @type {string} */ (reader.readString());
      msg.setFit2(value);
      break;
    case 94:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeetPerSecond(value);
      break;
    case 95:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrameMaterial(value);
      break;
    case 96:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaliber1(value);
      break;
    case 97:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaliber2(value);
      break;
    case 98:
      var value = /** @type {string} */ (reader.readString());
      msg.setGrainWeight(value);
      break;
    case 99:
      var value = /** @type {string} */ (reader.readString());
      msg.setGripsStock(value);
      break;
    case 100:
      var value = /** @type {string} */ (reader.readString());
      msg.setHand(value);
      break;
    case 101:
      var value = /** @type {string} */ (reader.readString());
      msg.setManufacturer(value);
      break;
    case 102:
      var value = /** @type {string} */ (reader.readString());
      msg.setManufacturerPart(value);
      break;
    case 103:
      var value = /** @type {string} */ (reader.readString());
      msg.setManufacturerWeight(value);
      break;
    case 104:
      var value = /** @type {string} */ (reader.readString());
      msg.setMoa(value);
      break;
    case 105:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel1(value);
      break;
    case 106:
      var value = /** @type {string} */ (reader.readString());
      msg.setModel2(value);
      break;
    case 107:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewStock(value);
      break;
    case 108:
      var value = /** @type {string} */ (reader.readString());
      msg.setNationalStockNumber(value);
      break;
    case 109:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjective(value);
      break;
    case 110:
      var value = /** @type {string} */ (reader.readString());
      msg.setOunceOfShot(value);
      break;
    case 111:
      var value = /** @type {string} */ (reader.readString());
      msg.setPackaging(value);
      break;
    case 112:
      var value = /** @type {string} */ (reader.readString());
      msg.setPower(value);
      break;
    case 113:
      var value = /** @type {string} */ (reader.readString());
      msg.setReticle(value);
      break;
    case 114:
      var value = /** @type {string} */ (reader.readString());
      msg.setSafety(value);
      break;
    case 115:
      var value = /** @type {string} */ (reader.readString());
      msg.setSights(value);
      break;
    case 116:
      var value = /** @type {string} */ (reader.readString());
      msg.setSize(value);
      break;
    case 117:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 118:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnitsPerBox(value);
      break;
    case 119:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnitsPerCase(value);
      break;
    case 120:
      var value = /** @type {string} */ (reader.readString());
      msg.setWtCharacteristics(value);
      break;
    case 121:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubCategory(value);
      break;
    case 129:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiameter(value);
      break;
    case 122:
      var value = new proto.admin.RsrProduct.RsrXref;
      reader.readMessage(value,proto.admin.RsrProduct.RsrXref.deserializeBinaryFromReader);
      msg.addXrefs(value);
      break;
    case 123:
      var value = new rpc_admin_image_pb.Image;
      reader.readMessage(value,rpc_admin_image_pb.Image.deserializeBinaryFromReader);
      msg.addImages(value);
      break;
    case 124:
      var value = new proto.admin.RsrProduct.RsrRestriction;
      reader.readMessage(value,proto.admin.RsrProduct.RsrRestriction.deserializeBinaryFromReader);
      msg.addRestrictions(value);
      break;
    case 125:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductMessageType(value);
      break;
    case 126:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductMessage(value);
      break;
    case 127:
      var value = /** @type {string} */ (reader.readString());
      msg.setSellCopy(value);
      break;
    case 128:
      var value = /** @type {string} */ (reader.readString());
      msg.addFeatures(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.RsrProduct.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.RsrProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.RsrProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.RsrProduct.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRsrStockNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpcCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProductDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDepartment();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getManufacturerId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRetailPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getRsrRegularPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getProductWeight();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getInventoryQuantity();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getModel();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getFullManufacturerName();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getManufacturerPartNumber();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAllocatedCloseoutDeleted();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getExpandedProductDescription();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getImageName();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getGroundShipmentsOnly();
  if (f) {
    writer.writeBool(
      67,
      f
    );
  }
  f = message.getAdultSignatureRequired();
  if (f) {
    writer.writeBool(
      68,
      f
    );
  }
  f = message.getBlockedFromDropShip();
  if (f) {
    writer.writeBool(
      69,
      f
    );
  }
  f = message.getDateEntered();
  if (f.length > 0) {
    writer.writeString(
      70,
      f
    );
  }
  f = message.getRetailMap();
  if (f !== 0.0) {
    writer.writeDouble(
      71,
      f
    );
  }
  f = message.getImageDisclaimer();
  if (f.length > 0) {
    writer.writeString(
      72,
      f
    );
  }
  f = message.getShippingLength();
  if (f !== 0.0) {
    writer.writeDouble(
      73,
      f
    );
  }
  f = message.getShippingWidth();
  if (f !== 0.0) {
    writer.writeDouble(
      74,
      f
    );
  }
  f = message.getShippingHeight();
  if (f !== 0.0) {
    writer.writeDouble(
      75,
      f
    );
  }
  f = message.getProp65();
  if (f) {
    writer.writeBool(
      76,
      f
    );
  }
  f = message.getFulfillment();
  if (f) {
    writer.writeBool(
      77,
      f
    );
  }
  f = message.getAccessories();
  if (f.length > 0) {
    writer.writeString(
      78,
      f
    );
  }
  f = message.getAction();
  if (f.length > 0) {
    writer.writeString(
      79,
      f
    );
  }
  f = message.getTypeOfBarrel();
  if (f.length > 0) {
    writer.writeString(
      80,
      f
    );
  }
  f = message.getBarrelLength();
  if (f.length > 0) {
    writer.writeString(
      81,
      f
    );
  }
  f = message.getCatalogCode();
  if (f.length > 0) {
    writer.writeString(
      82,
      f
    );
  }
  f = message.getChamber();
  if (f.length > 0) {
    writer.writeString(
      83,
      f
    );
  }
  f = message.getChokes();
  if (f.length > 0) {
    writer.writeString(
      84,
      f
    );
  }
  f = message.getCondition();
  if (f.length > 0) {
    writer.writeString(
      85,
      f
    );
  }
  f = message.getCapacity();
  if (f.length > 0) {
    writer.writeString(
      86,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      87,
      f
    );
  }
  f = message.getDram();
  if (f.length > 0) {
    writer.writeString(
      88,
      f
    );
  }
  f = message.getEdge();
  if (f.length > 0) {
    writer.writeString(
      89,
      f
    );
  }
  f = message.getFiringCasing();
  if (f.length > 0) {
    writer.writeString(
      90,
      f
    );
  }
  f = message.getFinishColor();
  if (f.length > 0) {
    writer.writeString(
      91,
      f
    );
  }
  f = message.getFit1();
  if (f.length > 0) {
    writer.writeString(
      92,
      f
    );
  }
  f = message.getFit2();
  if (f.length > 0) {
    writer.writeString(
      93,
      f
    );
  }
  f = message.getFeetPerSecond();
  if (f.length > 0) {
    writer.writeString(
      94,
      f
    );
  }
  f = message.getFrameMaterial();
  if (f.length > 0) {
    writer.writeString(
      95,
      f
    );
  }
  f = message.getCaliber1();
  if (f.length > 0) {
    writer.writeString(
      96,
      f
    );
  }
  f = message.getCaliber2();
  if (f.length > 0) {
    writer.writeString(
      97,
      f
    );
  }
  f = message.getGrainWeight();
  if (f.length > 0) {
    writer.writeString(
      98,
      f
    );
  }
  f = message.getGripsStock();
  if (f.length > 0) {
    writer.writeString(
      99,
      f
    );
  }
  f = message.getHand();
  if (f.length > 0) {
    writer.writeString(
      100,
      f
    );
  }
  f = message.getManufacturer();
  if (f.length > 0) {
    writer.writeString(
      101,
      f
    );
  }
  f = message.getManufacturerPart();
  if (f.length > 0) {
    writer.writeString(
      102,
      f
    );
  }
  f = message.getManufacturerWeight();
  if (f.length > 0) {
    writer.writeString(
      103,
      f
    );
  }
  f = message.getMoa();
  if (f.length > 0) {
    writer.writeString(
      104,
      f
    );
  }
  f = message.getModel1();
  if (f.length > 0) {
    writer.writeString(
      105,
      f
    );
  }
  f = message.getModel2();
  if (f.length > 0) {
    writer.writeString(
      106,
      f
    );
  }
  f = message.getNewStock();
  if (f.length > 0) {
    writer.writeString(
      107,
      f
    );
  }
  f = message.getNationalStockNumber();
  if (f.length > 0) {
    writer.writeString(
      108,
      f
    );
  }
  f = message.getObjective();
  if (f.length > 0) {
    writer.writeString(
      109,
      f
    );
  }
  f = message.getOunceOfShot();
  if (f.length > 0) {
    writer.writeString(
      110,
      f
    );
  }
  f = message.getPackaging();
  if (f.length > 0) {
    writer.writeString(
      111,
      f
    );
  }
  f = message.getPower();
  if (f.length > 0) {
    writer.writeString(
      112,
      f
    );
  }
  f = message.getReticle();
  if (f.length > 0) {
    writer.writeString(
      113,
      f
    );
  }
  f = message.getSafety();
  if (f.length > 0) {
    writer.writeString(
      114,
      f
    );
  }
  f = message.getSights();
  if (f.length > 0) {
    writer.writeString(
      115,
      f
    );
  }
  f = message.getSize();
  if (f.length > 0) {
    writer.writeString(
      116,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      117,
      f
    );
  }
  f = message.getUnitsPerBox();
  if (f.length > 0) {
    writer.writeString(
      118,
      f
    );
  }
  f = message.getUnitsPerCase();
  if (f.length > 0) {
    writer.writeString(
      119,
      f
    );
  }
  f = message.getWtCharacteristics();
  if (f.length > 0) {
    writer.writeString(
      120,
      f
    );
  }
  f = message.getSubCategory();
  if (f.length > 0) {
    writer.writeString(
      121,
      f
    );
  }
  f = message.getDiameter();
  if (f.length > 0) {
    writer.writeString(
      129,
      f
    );
  }
  f = message.getXrefsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      122,
      f,
      proto.admin.RsrProduct.RsrXref.serializeBinaryToWriter
    );
  }
  f = message.getImagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      123,
      f,
      rpc_admin_image_pb.Image.serializeBinaryToWriter
    );
  }
  f = message.getRestrictionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      124,
      f,
      proto.admin.RsrProduct.RsrRestriction.serializeBinaryToWriter
    );
  }
  f = message.getProductMessageType();
  if (f.length > 0) {
    writer.writeString(
      125,
      f
    );
  }
  f = message.getProductMessage();
  if (f.length > 0) {
    writer.writeString(
      126,
      f
    );
  }
  f = message.getSellCopy();
  if (f.length > 0) {
    writer.writeString(
      127,
      f
    );
  }
  f = message.getFeaturesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      128,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.RsrProduct.RsrXref.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.RsrProduct.RsrXref.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.RsrProduct.RsrXref} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.RsrProduct.RsrXref.toObject = function(includeInstance, msg) {
  var f, obj = {
    associatedRsrStockNumber: jspb.Message.getFieldWithDefault(msg, 1, ""),
    associatedDepartmentNumber: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.RsrProduct.RsrXref}
 */
proto.admin.RsrProduct.RsrXref.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.RsrProduct.RsrXref;
  return proto.admin.RsrProduct.RsrXref.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.RsrProduct.RsrXref} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.RsrProduct.RsrXref}
 */
proto.admin.RsrProduct.RsrXref.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssociatedRsrStockNumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssociatedDepartmentNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.RsrProduct.RsrXref.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.RsrProduct.RsrXref.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.RsrProduct.RsrXref} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.RsrProduct.RsrXref.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssociatedRsrStockNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAssociatedDepartmentNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string associated_rsr_stock_number = 1;
 * @return {string}
 */
proto.admin.RsrProduct.RsrXref.prototype.getAssociatedRsrStockNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.RsrXref.prototype.setAssociatedRsrStockNumber = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string associated_department_number = 2;
 * @return {string}
 */
proto.admin.RsrProduct.RsrXref.prototype.getAssociatedDepartmentNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.RsrXref.prototype.setAssociatedDepartmentNumber = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.RsrProduct.RsrRestriction.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.RsrProduct.RsrRestriction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.RsrProduct.RsrRestriction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.RsrProduct.RsrRestriction.toObject = function(includeInstance, msg) {
  var f, obj = {
    state: jspb.Message.getFieldWithDefault(msg, 1, ""),
    municipality: jspb.Message.getFieldWithDefault(msg, 2, ""),
    level: jspb.Message.getFieldWithDefault(msg, 3, 0),
    detail: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.RsrProduct.RsrRestriction}
 */
proto.admin.RsrProduct.RsrRestriction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.RsrProduct.RsrRestriction;
  return proto.admin.RsrProduct.RsrRestriction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.RsrProduct.RsrRestriction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.RsrProduct.RsrRestriction}
 */
proto.admin.RsrProduct.RsrRestriction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMunicipality(value);
      break;
    case 3:
      var value = /** @type {!proto.admin.RsrProduct.RsrRestriction.Level} */ (reader.readEnum());
      msg.setLevel(value);
      break;
    case 4:
      var value = /** @type {!proto.admin.RsrProduct.RsrRestriction.Detail} */ (reader.readEnum());
      msg.setDetail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.RsrProduct.RsrRestriction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.RsrProduct.RsrRestriction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.RsrProduct.RsrRestriction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.RsrProduct.RsrRestriction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMunicipality();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLevel();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDetail();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.admin.RsrProduct.RsrRestriction.Level = {
  LEVEL_UNKNOWN: 0,
  CITY: 1,
  COUNTY: 2,
  STATE: 3
};

/**
 * @enum {number}
 */
proto.admin.RsrProduct.RsrRestriction.Detail = {
  DETAIL_UNKNOWN: 0,
  ALL: 1,
  FULFILLMENT: 2,
  AFFIDAVIT: 3,
  LICENSE: 4
};

/**
 * optional string state = 1;
 * @return {string}
 */
proto.admin.RsrProduct.RsrRestriction.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.RsrRestriction.prototype.setState = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string municipality = 2;
 * @return {string}
 */
proto.admin.RsrProduct.RsrRestriction.prototype.getMunicipality = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.RsrRestriction.prototype.setMunicipality = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Level level = 3;
 * @return {!proto.admin.RsrProduct.RsrRestriction.Level}
 */
proto.admin.RsrProduct.RsrRestriction.prototype.getLevel = function() {
  return /** @type {!proto.admin.RsrProduct.RsrRestriction.Level} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.admin.RsrProduct.RsrRestriction.Level} value */
proto.admin.RsrProduct.RsrRestriction.prototype.setLevel = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional Detail detail = 4;
 * @return {!proto.admin.RsrProduct.RsrRestriction.Detail}
 */
proto.admin.RsrProduct.RsrRestriction.prototype.getDetail = function() {
  return /** @type {!proto.admin.RsrProduct.RsrRestriction.Detail} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.admin.RsrProduct.RsrRestriction.Detail} value */
proto.admin.RsrProduct.RsrRestriction.prototype.setDetail = function(value) {
  jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string rsr_stock_number = 1;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getRsrStockNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setRsrStockNumber = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string upc_code = 2;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getUpcCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setUpcCode = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string product_description = 3;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getProductDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setProductDescription = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string department = 4;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getDepartment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setDepartment = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string manufacturer_id = 5;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getManufacturerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setManufacturerId = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional double retail_price = 6;
 * @return {number}
 */
proto.admin.RsrProduct.prototype.getRetailPrice = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 6, 0.0));
};


/** @param {number} value */
proto.admin.RsrProduct.prototype.setRetailPrice = function(value) {
  jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double rsr_regular_price = 7;
 * @return {number}
 */
proto.admin.RsrProduct.prototype.getRsrRegularPrice = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 7, 0.0));
};


/** @param {number} value */
proto.admin.RsrProduct.prototype.setRsrRegularPrice = function(value) {
  jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double product_weight = 8;
 * @return {number}
 */
proto.admin.RsrProduct.prototype.getProductWeight = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 8, 0.0));
};


/** @param {number} value */
proto.admin.RsrProduct.prototype.setProductWeight = function(value) {
  jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional int32 inventory_quantity = 9;
 * @return {number}
 */
proto.admin.RsrProduct.prototype.getInventoryQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.admin.RsrProduct.prototype.setInventoryQuantity = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string model = 10;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setModel = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string full_manufacturer_name = 11;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getFullManufacturerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setFullManufacturerName = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string manufacturer_part_number = 12;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getManufacturerPartNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setManufacturerPartNumber = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string allocated_closeout_deleted = 13;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getAllocatedCloseoutDeleted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setAllocatedCloseoutDeleted = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string expanded_product_description = 14;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getExpandedProductDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setExpandedProductDescription = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string image_name = 15;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getImageName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setImageName = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional bool ground_shipments_only = 67;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.admin.RsrProduct.prototype.getGroundShipmentsOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 67, false));
};


/** @param {boolean} value */
proto.admin.RsrProduct.prototype.setGroundShipmentsOnly = function(value) {
  jspb.Message.setProto3BooleanField(this, 67, value);
};


/**
 * optional bool adult_signature_required = 68;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.admin.RsrProduct.prototype.getAdultSignatureRequired = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 68, false));
};


/** @param {boolean} value */
proto.admin.RsrProduct.prototype.setAdultSignatureRequired = function(value) {
  jspb.Message.setProto3BooleanField(this, 68, value);
};


/**
 * optional bool blocked_from_drop_ship = 69;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.admin.RsrProduct.prototype.getBlockedFromDropShip = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 69, false));
};


/** @param {boolean} value */
proto.admin.RsrProduct.prototype.setBlockedFromDropShip = function(value) {
  jspb.Message.setProto3BooleanField(this, 69, value);
};


/**
 * optional string date_entered = 70;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getDateEntered = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 70, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setDateEntered = function(value) {
  jspb.Message.setProto3StringField(this, 70, value);
};


/**
 * optional double retail_map = 71;
 * @return {number}
 */
proto.admin.RsrProduct.prototype.getRetailMap = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 71, 0.0));
};


/** @param {number} value */
proto.admin.RsrProduct.prototype.setRetailMap = function(value) {
  jspb.Message.setProto3FloatField(this, 71, value);
};


/**
 * optional string image_disclaimer = 72;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getImageDisclaimer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 72, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setImageDisclaimer = function(value) {
  jspb.Message.setProto3StringField(this, 72, value);
};


/**
 * optional double shipping_length = 73;
 * @return {number}
 */
proto.admin.RsrProduct.prototype.getShippingLength = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 73, 0.0));
};


/** @param {number} value */
proto.admin.RsrProduct.prototype.setShippingLength = function(value) {
  jspb.Message.setProto3FloatField(this, 73, value);
};


/**
 * optional double shipping_width = 74;
 * @return {number}
 */
proto.admin.RsrProduct.prototype.getShippingWidth = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 74, 0.0));
};


/** @param {number} value */
proto.admin.RsrProduct.prototype.setShippingWidth = function(value) {
  jspb.Message.setProto3FloatField(this, 74, value);
};


/**
 * optional double shipping_height = 75;
 * @return {number}
 */
proto.admin.RsrProduct.prototype.getShippingHeight = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 75, 0.0));
};


/** @param {number} value */
proto.admin.RsrProduct.prototype.setShippingHeight = function(value) {
  jspb.Message.setProto3FloatField(this, 75, value);
};


/**
 * optional bool prop_65 = 76;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.admin.RsrProduct.prototype.getProp65 = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 76, false));
};


/** @param {boolean} value */
proto.admin.RsrProduct.prototype.setProp65 = function(value) {
  jspb.Message.setProto3BooleanField(this, 76, value);
};


/**
 * optional bool fulfillment = 77;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.admin.RsrProduct.prototype.getFulfillment = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 77, false));
};


/** @param {boolean} value */
proto.admin.RsrProduct.prototype.setFulfillment = function(value) {
  jspb.Message.setProto3BooleanField(this, 77, value);
};


/**
 * optional string accessories = 78;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getAccessories = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 78, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setAccessories = function(value) {
  jspb.Message.setProto3StringField(this, 78, value);
};


/**
 * optional string action = 79;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getAction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 79, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setAction = function(value) {
  jspb.Message.setProto3StringField(this, 79, value);
};


/**
 * optional string type_of_barrel = 80;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getTypeOfBarrel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 80, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setTypeOfBarrel = function(value) {
  jspb.Message.setProto3StringField(this, 80, value);
};


/**
 * optional string barrel_length = 81;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getBarrelLength = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 81, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setBarrelLength = function(value) {
  jspb.Message.setProto3StringField(this, 81, value);
};


/**
 * optional string catalog_code = 82;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getCatalogCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 82, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setCatalogCode = function(value) {
  jspb.Message.setProto3StringField(this, 82, value);
};


/**
 * optional string chamber = 83;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getChamber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 83, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setChamber = function(value) {
  jspb.Message.setProto3StringField(this, 83, value);
};


/**
 * optional string chokes = 84;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getChokes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 84, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setChokes = function(value) {
  jspb.Message.setProto3StringField(this, 84, value);
};


/**
 * optional string condition = 85;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getCondition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 85, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setCondition = function(value) {
  jspb.Message.setProto3StringField(this, 85, value);
};


/**
 * optional string capacity = 86;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getCapacity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 86, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setCapacity = function(value) {
  jspb.Message.setProto3StringField(this, 86, value);
};


/**
 * optional string description = 87;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 87, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setDescription = function(value) {
  jspb.Message.setProto3StringField(this, 87, value);
};


/**
 * optional string dram = 88;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getDram = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 88, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setDram = function(value) {
  jspb.Message.setProto3StringField(this, 88, value);
};


/**
 * optional string edge = 89;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getEdge = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 89, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setEdge = function(value) {
  jspb.Message.setProto3StringField(this, 89, value);
};


/**
 * optional string firing_casing = 90;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getFiringCasing = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 90, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setFiringCasing = function(value) {
  jspb.Message.setProto3StringField(this, 90, value);
};


/**
 * optional string finish_color = 91;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getFinishColor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 91, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setFinishColor = function(value) {
  jspb.Message.setProto3StringField(this, 91, value);
};


/**
 * optional string fit1 = 92;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getFit1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 92, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setFit1 = function(value) {
  jspb.Message.setProto3StringField(this, 92, value);
};


/**
 * optional string fit2 = 93;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getFit2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 93, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setFit2 = function(value) {
  jspb.Message.setProto3StringField(this, 93, value);
};


/**
 * optional string feet_per_second = 94;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getFeetPerSecond = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 94, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setFeetPerSecond = function(value) {
  jspb.Message.setProto3StringField(this, 94, value);
};


/**
 * optional string frame_material = 95;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getFrameMaterial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 95, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setFrameMaterial = function(value) {
  jspb.Message.setProto3StringField(this, 95, value);
};


/**
 * optional string caliber1 = 96;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getCaliber1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 96, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setCaliber1 = function(value) {
  jspb.Message.setProto3StringField(this, 96, value);
};


/**
 * optional string caliber2 = 97;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getCaliber2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 97, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setCaliber2 = function(value) {
  jspb.Message.setProto3StringField(this, 97, value);
};


/**
 * optional string grain_weight = 98;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getGrainWeight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 98, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setGrainWeight = function(value) {
  jspb.Message.setProto3StringField(this, 98, value);
};


/**
 * optional string grips_stock = 99;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getGripsStock = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 99, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setGripsStock = function(value) {
  jspb.Message.setProto3StringField(this, 99, value);
};


/**
 * optional string hand = 100;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getHand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 100, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setHand = function(value) {
  jspb.Message.setProto3StringField(this, 100, value);
};


/**
 * optional string manufacturer = 101;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getManufacturer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 101, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setManufacturer = function(value) {
  jspb.Message.setProto3StringField(this, 101, value);
};


/**
 * optional string manufacturer_part = 102;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getManufacturerPart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 102, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setManufacturerPart = function(value) {
  jspb.Message.setProto3StringField(this, 102, value);
};


/**
 * optional string manufacturer_weight = 103;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getManufacturerWeight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 103, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setManufacturerWeight = function(value) {
  jspb.Message.setProto3StringField(this, 103, value);
};


/**
 * optional string moa = 104;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getMoa = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 104, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setMoa = function(value) {
  jspb.Message.setProto3StringField(this, 104, value);
};


/**
 * optional string model1 = 105;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getModel1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 105, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setModel1 = function(value) {
  jspb.Message.setProto3StringField(this, 105, value);
};


/**
 * optional string model2 = 106;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getModel2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 106, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setModel2 = function(value) {
  jspb.Message.setProto3StringField(this, 106, value);
};


/**
 * optional string new_stock = 107;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getNewStock = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 107, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setNewStock = function(value) {
  jspb.Message.setProto3StringField(this, 107, value);
};


/**
 * optional string national_stock_number = 108;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getNationalStockNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 108, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setNationalStockNumber = function(value) {
  jspb.Message.setProto3StringField(this, 108, value);
};


/**
 * optional string objective = 109;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getObjective = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 109, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setObjective = function(value) {
  jspb.Message.setProto3StringField(this, 109, value);
};


/**
 * optional string ounce_of_shot = 110;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getOunceOfShot = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 110, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setOunceOfShot = function(value) {
  jspb.Message.setProto3StringField(this, 110, value);
};


/**
 * optional string packaging = 111;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getPackaging = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 111, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setPackaging = function(value) {
  jspb.Message.setProto3StringField(this, 111, value);
};


/**
 * optional string power = 112;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getPower = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 112, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setPower = function(value) {
  jspb.Message.setProto3StringField(this, 112, value);
};


/**
 * optional string reticle = 113;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getReticle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 113, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setReticle = function(value) {
  jspb.Message.setProto3StringField(this, 113, value);
};


/**
 * optional string safety = 114;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getSafety = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 114, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setSafety = function(value) {
  jspb.Message.setProto3StringField(this, 114, value);
};


/**
 * optional string sights = 115;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getSights = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 115, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setSights = function(value) {
  jspb.Message.setProto3StringField(this, 115, value);
};


/**
 * optional string size = 116;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getSize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 116, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setSize = function(value) {
  jspb.Message.setProto3StringField(this, 116, value);
};


/**
 * optional string type = 117;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 117, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setType = function(value) {
  jspb.Message.setProto3StringField(this, 117, value);
};


/**
 * optional string units_per_box = 118;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getUnitsPerBox = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 118, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setUnitsPerBox = function(value) {
  jspb.Message.setProto3StringField(this, 118, value);
};


/**
 * optional string units_per_case = 119;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getUnitsPerCase = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 119, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setUnitsPerCase = function(value) {
  jspb.Message.setProto3StringField(this, 119, value);
};


/**
 * optional string wt_characteristics = 120;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getWtCharacteristics = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 120, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setWtCharacteristics = function(value) {
  jspb.Message.setProto3StringField(this, 120, value);
};


/**
 * optional string sub_category = 121;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getSubCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 121, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setSubCategory = function(value) {
  jspb.Message.setProto3StringField(this, 121, value);
};


/**
 * optional string diameter = 129;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getDiameter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 129, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setDiameter = function(value) {
  jspb.Message.setProto3StringField(this, 129, value);
};


/**
 * repeated RsrXref xrefs = 122;
 * @return {!Array<!proto.admin.RsrProduct.RsrXref>}
 */
proto.admin.RsrProduct.prototype.getXrefsList = function() {
  return /** @type{!Array<!proto.admin.RsrProduct.RsrXref>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admin.RsrProduct.RsrXref, 122));
};


/** @param {!Array<!proto.admin.RsrProduct.RsrXref>} value */
proto.admin.RsrProduct.prototype.setXrefsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 122, value);
};


/**
 * @param {!proto.admin.RsrProduct.RsrXref=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.RsrProduct.RsrXref}
 */
proto.admin.RsrProduct.prototype.addXrefs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 122, opt_value, proto.admin.RsrProduct.RsrXref, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.RsrProduct.prototype.clearXrefsList = function() {
  this.setXrefsList([]);
};


/**
 * repeated Image images = 123;
 * @return {!Array<!proto.admin.Image>}
 */
proto.admin.RsrProduct.prototype.getImagesList = function() {
  return /** @type{!Array<!proto.admin.Image>} */ (
    jspb.Message.getRepeatedWrapperField(this, rpc_admin_image_pb.Image, 123));
};


/** @param {!Array<!proto.admin.Image>} value */
proto.admin.RsrProduct.prototype.setImagesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 123, value);
};


/**
 * @param {!proto.admin.Image=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.Image}
 */
proto.admin.RsrProduct.prototype.addImages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 123, opt_value, proto.admin.Image, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.RsrProduct.prototype.clearImagesList = function() {
  this.setImagesList([]);
};


/**
 * repeated RsrRestriction restrictions = 124;
 * @return {!Array<!proto.admin.RsrProduct.RsrRestriction>}
 */
proto.admin.RsrProduct.prototype.getRestrictionsList = function() {
  return /** @type{!Array<!proto.admin.RsrProduct.RsrRestriction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admin.RsrProduct.RsrRestriction, 124));
};


/** @param {!Array<!proto.admin.RsrProduct.RsrRestriction>} value */
proto.admin.RsrProduct.prototype.setRestrictionsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 124, value);
};


/**
 * @param {!proto.admin.RsrProduct.RsrRestriction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admin.RsrProduct.RsrRestriction}
 */
proto.admin.RsrProduct.prototype.addRestrictions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 124, opt_value, proto.admin.RsrProduct.RsrRestriction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.RsrProduct.prototype.clearRestrictionsList = function() {
  this.setRestrictionsList([]);
};


/**
 * optional string product_message_type = 125;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getProductMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 125, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setProductMessageType = function(value) {
  jspb.Message.setProto3StringField(this, 125, value);
};


/**
 * optional string product_message = 126;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getProductMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 126, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setProductMessage = function(value) {
  jspb.Message.setProto3StringField(this, 126, value);
};


/**
 * optional string sell_copy = 127;
 * @return {string}
 */
proto.admin.RsrProduct.prototype.getSellCopy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 127, ""));
};


/** @param {string} value */
proto.admin.RsrProduct.prototype.setSellCopy = function(value) {
  jspb.Message.setProto3StringField(this, 127, value);
};


/**
 * repeated string features = 128;
 * @return {!Array<string>}
 */
proto.admin.RsrProduct.prototype.getFeaturesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 128));
};


/** @param {!Array<string>} value */
proto.admin.RsrProduct.prototype.setFeaturesList = function(value) {
  jspb.Message.setField(this, 128, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 */
proto.admin.RsrProduct.prototype.addFeatures = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 128, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.admin.RsrProduct.prototype.clearFeaturesList = function() {
  this.setFeaturesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admin.GetRsrProductRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.admin.GetRsrProductRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admin.GetRsrProductRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.GetRsrProductRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    rsrStockNumber: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admin.GetRsrProductRequest}
 */
proto.admin.GetRsrProductRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admin.GetRsrProductRequest;
  return proto.admin.GetRsrProductRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admin.GetRsrProductRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admin.GetRsrProductRequest}
 */
proto.admin.GetRsrProductRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRsrStockNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admin.GetRsrProductRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admin.GetRsrProductRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admin.GetRsrProductRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admin.GetRsrProductRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRsrStockNumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string rsr_stock_number = 1;
 * @return {string}
 */
proto.admin.GetRsrProductRequest.prototype.getRsrStockNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.admin.GetRsrProductRequest.prototype.setRsrStockNumber = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.admin);
